import React, { useState, useEffect, useRef } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@store/hooks';
import { PROFILE_PATH } from '@constants/routes';
import { ADMIN, HOSPITAL } from '@constants/constants';
import { capitalizeFirstLetter } from '@utils/sharedUtils';
import { DEFAULT_PROFILE_SRC } from '@constants/images';

const TopNav = () => {
    const navigate = useNavigate();
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const profileRef = useRef<HTMLDivElement>(null);
    const userRole = useAppSelector((state) => state.login.loggedInUserRole);
    const userName = useAppSelector((state) => state.login.loggedInUserName);
    const [profileImage, setProfileImage] = useState<string>(DEFAULT_PROFILE_SRC);

    const profileImageUrl = useAppSelector((state) => state.login.profileImageUrl);

    useEffect(() => {
        const fetchImage = async () => {
            if (profileImageUrl) {
                setProfileImage(profileImageUrl);
            } else {
                setProfileImage(DEFAULT_PROFILE_SRC);
            }
        };
        fetchImage();

        const handleClickOutside = (event: MouseEvent) => {
            if (profileRef.current && !profileRef.current.contains(event.target as Node)) {
                setIsProfileOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [profileImageUrl]);

    const getGreetingEmoji = () => '👋';

    return (
        <div
            style={{
                height: 68,
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 24px',
                borderBottom: '1px solid #F1F5F9',
                position: 'sticky',
                top: 0,
                zIndex: 40,
            }}
        >
            {/* Left: Welcome Message */}
            <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ fontSize: 15, fontWeight: 700, color: '#0F172A' }}>
                        Welcome back, {capitalizeFirstLetter(userName)} {getGreetingEmoji()}
                    </span>
                </div>
                <p style={{ fontSize: 12, color: '#94A3B8', margin: 0, marginTop: 2 }}>
                    Here's what's happening with your infusion devices today.
                </p>
            </div>

            {/* Right: Avatar */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                {/* User Avatar + Info */}
                <div ref={profileRef} style={{ position: 'relative' }}>
                    <button
                        onClick={() => {
                            setIsProfileOpen(!isProfileOpen);
                            navigate(PROFILE_PATH);
                        }}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px 6px',
                            borderRadius: 10,
                            transition: 'background 0.2s',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = '#F8FAFC')}
                        onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                    >
                        <img
                            src={profileImage}
                            alt="Profile"
                            style={{
                                width: 38,
                                height: 38,
                                borderRadius: '50%',
                                objectFit: 'cover',
                                border: '2px solid #E2E8F0',
                            }}
                        />
                        <div style={{ textAlign: 'left' }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: '#0F172A', lineHeight: 1.3 }}>
                                {capitalizeFirstLetter(userName)}
                            </div>
                            <div style={{ fontSize: 11, color: '#94A3B8', lineHeight: 1.3 }}>
                                {capitalizeFirstLetter(userRole)}
                            </div>
                        </div>
                        <MdKeyboardArrowDown style={{ fontSize: 18, color: '#94A3B8' }} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TopNav;
